<script setup lang="ts">
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import * as AssetsUtils from "@/helpers/assetsUtils"
import {useMatches} from "vue-responsiveness";
import {useSearchStore} from "@/stores/searchStore";

const {t} = useI18n(); // Initialize the i18n function

const model = defineModel<number[]>()

const open = ref(false);
const searchStore=useSearchStore()
const matches = useMatches()
const inputWidth = computed(() => matches.isMin('min') ? 'w-full' : 'w-[10vw]');

function selectCategory(category) {
  model.value = [category.id];
  open.value = false
}

const selectedCategoryName = computed(() => {
  if(!model.value || model.value.length <=0 ) return t('boat.selectOption');
  return searchStore.filters.categories.find((c) => c.id == model.value[0]).name
})

const hasCategory = computed(() => {
  return model.value && model.value.length > 0
})

</script>

<template>
  <div class="relative flex">
    <VTextField :placeholder="t('boatType')"
                variant="underlined"
                :model-value="selectedCategoryName" readonly
                :class="inputWidth" @click="open = !open">
      <template #prepend-inner>
        <img v-if="hasCategory"
             :src="AssetsUtils.getCategoryImage(model[0])" :alt="t('boatType')" class="min-w-5"/>
      </template>
    </VTextField>
    <div v-if="open" v-click-outside="() => open = false"
         class="w-fit shadow-2xl absolute top-full bg-white flex flex-col z-20">
      <div class="w-max flex flex-row gap-3 py-7 px-5 z-[6200]">
        <div class="flex flex-col gap-2">
          <div class=" responsive-body-small mb-3">{{ t('selectBoatType') }}</div>
          <div class="flex flex-col gap-2">
            <div v-for="(category) in searchStore.filters.categories" :key="category.id"
                 @click="selectCategory(category);"
                 :class="`bg-background-light font-semibold  responsive-body-small px-3.5 py-2.5 type select-none cursor-pointer rounded border-2
                 ${searchStore.selectedFilters.categories.indexOf(category.id) >=0 ? 'border-primary-blue' : 'border-transparent'}`">
              <div class="flex align-center gap-2 ">
                <img class="boat-icon w-5.5" :src="AssetsUtils.getCategoryImage(category.id)" :alt="category.name">
                <div class="text-nowrap">{{ category.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>

